import { connect } from 'react-redux'
import View from './RequestResetPasswordForm'
import compose from 'ramda/src/compose'
import { clear, requestPasswordReset } from '../../../../store/modules/session'
import { componentWillUnmount } from '../../../Lifecycles'

const mapStateToProps = state => ({
  locale: state.router.locale,
  isSubmitting: state.session.isSubmitting,
  isSuccess: state.session.isSuccessfullySubmitted,
  error: state.session.error,
})

const mapDispatchToProps = dispatch => ({
  requestPasswordReset: compose(dispatch, requestPasswordReset),
  clear: compose(dispatch, clear),
})

// willUnmount :: Props -> Action CLEAR
const willUnmount = ({ clear }) => clear()

// lifecycles :: React.Component -> React.Component
const lifecycles = componentWillUnmount(willUnmount)(View)

const RequestResetPasswordForm = connect(mapStateToProps, mapDispatchToProps)(lifecycles)

export default RequestResetPasswordForm
